import React from "react";
import { Box, CircularProgress } from "@mui/material";

const Loader = ({
  height,
  width,
  color = "inherit",
}: {
  height?: number | string;
  width?: number | string;
  color?: string;
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height={height || "100vh"}
      width={width || "100%"}
    >
      <CircularProgress sx={{ fontSize: 12, color: color }} />
    </Box>
  );
};

export default Loader;
